/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import OfferCard from "../../components/Cards/OfferCard";
import AddOffer from "../../components/modal/AddOffer";
import DeleteOffer from "../../components/modal/DeleteOffer";
import { DeleteApiCaller, getApiCaller } from "../../libs/apiCaller";

const Offer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
  const [deleteOfferModalOpen, setDeleteOfferModalOpen] = useState(false);
  const [deleteOfferId, setDeleteOfferId] = useState("");
  const [offerList, setOfferList] = useState([]);

  useEffect(() => {
    getOfferData();
  }, []);

  const getOfferData = async (showLoading) => {
    showLoading ? setIsLoading(false) : setIsLoading(true);
    const endPoint = `offer_fetch`;
    try {
      const response = await getApiCaller(endPoint);
      setOfferList(response?.data?.response_data);
    } catch (error) {
      toast.error("Failed to fetch data.");
    }
    setIsLoading(false);
  };

  const handleCloseModal = () => {
    setIsOfferModalOpen(false);
  };

  const handleDeleteOffer = async () => {
    setIsDeleteLoading(true);
    if (deleteOfferId) {
      const endPoint = `offer_delete?offer_id=${deleteOfferId}`;
      try {
        const response = await DeleteApiCaller(endPoint);
        if (response?.data.response_code === 200) {
          toast.success(response.data.response_message);
          getOfferData(true);
          handleCloseDeleteModal();
        } else {
          toast.error(response?.data?.response_message);
        }
      } catch (error) {
        toast.error(error?.message);
      }
    }
    setIsDeleteLoading(false);
  };

  const handleCloseDeleteModal = () => {
    setDeleteOfferModalOpen(false);
    setDeleteOfferId("");
    setIsDeleteLoading(false);
  };

  return (
    <>
      <div className="px-4 md:px-10">
        <div className="border border-1 flex justify-between px-4 py-3 rounded-t-2xl mt-4 bg-white">
          <p className="text-[#284184] font-bold text-xl">Offers</p>
          <button
            className="text-[#E0A256] hover:underline text-base flex items-center space-x-1"
            onClick={() => {
              setIsOfferModalOpen(true);
            }}
            disabled={isLoading}
          >
            <FaPlus />
            <span>Add Offer</span>
          </button>
        </div>
        <div className="border px-4 py-3 rounded-b-2xl text-xl bg-white">
          {isLoading ? (
            <div className="flex justify-center items-center h-[70vh]">
              <PropagateLoader color="#284184" loading={true} size={10} />
            </div>
          ) : offerList.length > 0 ? (
            <OfferCard
              offers={offerList}
              setDeleteOfferModalOpen={setDeleteOfferModalOpen}
              setDeleteOfferId={setDeleteOfferId}
            />
          ) : (
            <p className="flex justify-center items-center h-[70vh]">
              Offer not found!
            </p>
          )}
        </div>
      </div>
      <AddOffer
        isOpen={isOfferModalOpen}
        onClose={handleCloseModal}
        getOfferData={getOfferData}
      />
      <DeleteOffer
        isOpen={deleteOfferModalOpen}
        onClose={handleCloseDeleteModal}
        isDeleteLoading={isDeleteLoading}
        handleDeleteOffer={handleDeleteOffer}
      />
    </>
  );
};

export default Offer;
